<template>
  <input v-model="displayValue"
        type="text" inputmode="decimal"
        v-restrict.decimalnumber
        @blur="setActive(false)"
        @focus="setActive(true)"/>
</template>

<script>
import format from '@/common/utilities/format';
export default {
    name: 'mvtInputDecimalNumber',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: true
        },
        prefix:{
            type: String,
            default: ''
        },
        suffix:{
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        maxDecimalPlaces : {
            type: Number,
            default: 3
        }
    },
    data: function() {
        return {
            actived: false,
            val: this.modelValue || 0
        }
    },
    watch: {
        modelValue() {
            this.val = this.modelValue;
        }
    },
    methods: {
        setActive(actived) {
            this.actived = actived;
            if (this.actived) {
                this.$emit('actived');
            }
        },
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.actived) {
                    return this.prefix + format.formatDecimalNumberByComma(this.val, this.maxDecimalPlaces);
                } else {
                    return (this.prefix + format.formatDecimalNumberByComma(this.val, this.maxDecimalPlaces) + this.suffix) || this.placeholder;
                }
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
                if (isNaN(newValue)) {
                    newValue = 0
                }
                this.val = newValue;
                this.$emit('update:modelValue', this.val);
            }
        }
    }
}
</script>
